import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundDecimals'
})
export class RoundDecimalsPipe implements PipeTransform {

  transform(value: number | undefined | null, decimalsAmount: number): number | string | undefined | null {

    if (value == null || isNaN(value)) {
      return value;
    }

    if (Number.isInteger(value)) {
      return value;
    }

    return parseFloat(Number(value).toFixed(decimalsAmount));
  }

}